<template>
  <base-modal ref="modal">
    <base-card shadow>
      <h3 v-if="isReply === true" class="tw-text-xl tw-font-thin">Reply</h3>
      <h3 v-else class="tw-text-xl tw-font-thin">Add Comment</h3>
      <base-form ref="form" v-model="isFormValid" class="tw-mt-5">
        <base-textarea v-model="value" :label="isReply === true ? 'Reply Message' : 'Comment'" required />
      </base-form>
      <div class="sm:tw-flex sm:tw-flex-row-reverse tw-mt-4">
        <base-button v-if="isReply === true" @click="saveNote" :loading="isLoading" class="tw-w-full sm:tw-w-auto sm:tw-ml-3">Send</base-button>
        <base-button v-else @click="saveNote" :loading="isLoading" class="tw-w-full sm:tw-w-auto sm:tw-ml-3">Save</base-button>
        <base-button @click="hide" type="flat" class="tw-w-full sm:tw-w-auto tw-mt-2 sm:tw-mt-0">
          Cancel
        </base-button>
      </div>
      <inline-error id="delete-activity-modal-error" :title="errorTitle" :message="errorMessage" :error="error" />
    </base-card>
  </base-modal>
</template>

<script>
import InlineError from "@/components/InlineError";

export default {
  components: {
    InlineError,
  },
  name: "AddNote",
  props: {
    businessId: String,
  },
  data() {
    return {
      isLoading: false,
      isFormValid: true,
      value: null,
      todoItemId: null,
      constant: null,
      errorTitle: "",
      errorMessage: "",
      error: null,
    };
  },
  computed: {
    isReply() {
      return this.constant === "ONLINE_SUPPORT_QUESTION" ? true : false;
    },
  },
  methods: {
    show(todoItemId, constant) {
      this.todoItemId = todoItemId;
      this.constant = constant;
      this.$refs.modal.show();
    },
    hide() {
      this.$refs.modal.hide();
    },
    reset() {
      this.todoItemId = null;
      this.value = null;
      this.isFormValid = true;
    },
    saveNote() {
      if (!this.$refs.form.validate()) return;
      this.isLoading = true;

      this.$axios
        .post(`/businesses/${this.businessId}/todo/${this.todoItemId}/notes`, { value: this.value })
        .then(() => {
          this.EventBus.$emit("GLOBAL_NOTIFY", {
            title: "Note Saved",
            message: `Your note was saved.`,
          });
          this.reset();
          this.hide();
          this.EventBus.$emit("activitiesUpdated");
        })
        .catch((err) => {
          this.errorTitle = `Error saving note`;
          this.errorMessage = "Sorry, we had trouble adding this note. The technicians have been notified. Please try again.";
          this.error = err;
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
  },
};
</script>
